export default __webpack_public_path__ + "static/media/joinBackground.ac238ad3.png";